import SearchForm from '@/components/SearchForm/SearchForm';
import { Order } from '@/types';
import React from 'react';

interface IDontKnowEmailProps {
  setCurrentPage: (
    page: 'emailVerify' | 'iDontKnowEmail' | 'ticketsFound' | 'noAccountFound',
  ) => void;
  handleTicketsFound: (foundOrders: Order[]) => void;
}

const IDontKnowEmail: React.FC<IDontKnowEmailProps> = ({ setCurrentPage, handleTicketsFound }) => {
  return (
    <>
      <SearchForm setCurrentPage={setCurrentPage} handleTicketsFound={handleTicketsFound} />
    </>
  );
};

export default IDontKnowEmail;
